import { ReactNode } from 'react';
import { AppBar, Stack, Box } from '@mui/material';

import Sidebar from './Sidebar';
import useAppNavigation from 'hooks/general/useAppNavigation';
import { UNAVAILABLE_SIDEBAR_ROUTES } from 'constants/ui/routes';
import { useAuth } from 'modules/auth/hooks';
import { colors } from 'theme/mui/colors';

type Props = {
  children: ReactNode;
};

const MainLayout = (props: Props) => {
  const { children } = props;
  const { currentPath } = useAppNavigation();
  const { user } = useAuth();

  const isSidebarAvailable = !UNAVAILABLE_SIDEBAR_ROUTES.includes(currentPath);

  return (
    <AppBar position="fixed" style={{ background: colors.background.base, color: 'inherit' }}>
      <Stack direction="row" width="100%">
        {isSidebarAvailable && user && <Sidebar />}
        <Box
          sx={{
            padding: {
              sm: '0rem 2rem 0rem 2rem',
              xs: '0rem 0.5rem 0rem 0.5rem',
            },
            overflow: 'auto',
            width: '100%',
            height: '100vh',
          }}
        >
          {children}
        </Box>
      </Stack>
    </AppBar>
  );
};

export default MainLayout;
